import { render, staticRenderFns } from "./SchoolEdit.vue?vue&type=template&id=536b56dc&scoped=true&"
import script from "./SchoolEdit.vue?vue&type=script&lang=ts&"
export * from "./SchoolEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolEdit.vue?vue&type=style&index=0&id=536b56dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b56dc",
  null
  
)

export default component.exports